import './_styles.scss';
import React from "react";
import { Item } from 'components';
import AirBed from 'assets/air_bed.png';

export default ({ data=[], caption='Our Products' }) => {

  return (
    <section className='Section-Item-List'>
      <div className="Item-List-Wrapper">

        <div className="Item-List-Caption">{caption}</div>

        <div className="Item-List-Grid">
          {data.map((a,i) =>
            <Item
              key={i}
              id={a.handle}
              title={a.title}
              category={a.category}
              price={a.pricing.price}
              image={a.images[0] || AirBed}
              brand={a.vendor.toUpperCase()}
            />
          )}
        </div>

      </div>
    </section>
  );
}
